/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Game studio API
 * Game studio API documentation OAS.
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreatePlayerCommand,
  ModifyPlayerCommand,
  PlayerConfirmationCommand,
  PlayerDetailDto,
  SendEmailConfirmationCommand,
  Unit
} from '../../backoffice-schemas';

import postApiPlayersMutator from '../../../lib/customInstance';
import putApiPlayersMutator from '../../../lib/customInstance';
import getApiPlayersMutator from '../../../lib/customInstance';
import postApiPlayersEmailConfirmationMutator from '../../../lib/customInstance';
import postApiPlayersSendEmailConfirmationMutator from '../../../lib/customInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const postApiPlayers = (
    createPlayerCommand: CreatePlayerCommand,
 options?: SecondParameter<typeof postApiPlayersMutator>,signal?: AbortSignal
) => {
      
      
      return postApiPlayersMutator<PlayerDetailDto>(
      {url: `https://api.dev.gocore.gg/api/Players`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPlayerCommand, signal
    },
      options);
    }
  


export const getPostApiPlayersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPlayers>>, TError,{data: CreatePlayerCommand}, TContext>, request?: SecondParameter<typeof postApiPlayersMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiPlayers>>, TError,{data: CreatePlayerCommand}, TContext> => {

const mutationKey = ['postApiPlayers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiPlayers>>, {data: CreatePlayerCommand}> = (props) => {
          const {data} = props ?? {};

          return  postApiPlayers(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiPlayersMutationResult = NonNullable<Awaited<ReturnType<typeof postApiPlayers>>>
    export type PostApiPlayersMutationBody = CreatePlayerCommand
    export type PostApiPlayersMutationError = unknown

    export const usePostApiPlayers = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPlayers>>, TError,{data: CreatePlayerCommand}, TContext>, request?: SecondParameter<typeof postApiPlayersMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiPlayers>>,
        TError,
        {data: CreatePlayerCommand},
        TContext
      > => {

      const mutationOptions = getPostApiPlayersMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const putApiPlayers = (
    modifyPlayerCommand: ModifyPlayerCommand,
 options?: SecondParameter<typeof putApiPlayersMutator>,) => {
      
      
      return putApiPlayersMutator<PlayerDetailDto>(
      {url: `https://api.dev.gocore.gg/api/Players`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: modifyPlayerCommand
    },
      options);
    }
  


export const getPutApiPlayersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiPlayers>>, TError,{data: ModifyPlayerCommand}, TContext>, request?: SecondParameter<typeof putApiPlayersMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof putApiPlayers>>, TError,{data: ModifyPlayerCommand}, TContext> => {

const mutationKey = ['putApiPlayers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiPlayers>>, {data: ModifyPlayerCommand}> = (props) => {
          const {data} = props ?? {};

          return  putApiPlayers(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiPlayersMutationResult = NonNullable<Awaited<ReturnType<typeof putApiPlayers>>>
    export type PutApiPlayersMutationBody = ModifyPlayerCommand
    export type PutApiPlayersMutationError = unknown

    export const usePutApiPlayers = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiPlayers>>, TError,{data: ModifyPlayerCommand}, TContext>, request?: SecondParameter<typeof putApiPlayersMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiPlayers>>,
        TError,
        {data: ModifyPlayerCommand},
        TContext
      > => {

      const mutationOptions = getPutApiPlayersMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const getApiPlayers = (
    
 options?: SecondParameter<typeof getApiPlayersMutator>,signal?: AbortSignal
) => {
      
      
      return getApiPlayersMutator<PlayerDetailDto>(
      {url: `https://api.dev.gocore.gg/api/Players`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiPlayersQueryKey = () => {
    return [`https://api.dev.gocore.gg/api/Players`] as const;
    }

    
export const getGetApiPlayersQueryOptions = <TData = Awaited<ReturnType<typeof getApiPlayers>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlayers>>, TError, TData>>, request?: SecondParameter<typeof getApiPlayersMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPlayersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPlayers>>> = ({ signal }) => getApiPlayers(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiPlayers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPlayersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPlayers>>>
export type GetApiPlayersQueryError = unknown


export function useGetApiPlayers<TData = Awaited<ReturnType<typeof getApiPlayers>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlayers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPlayers>>,
          TError,
          Awaited<ReturnType<typeof getApiPlayers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApiPlayersMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPlayers<TData = Awaited<ReturnType<typeof getApiPlayers>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlayers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPlayers>>,
          TError,
          Awaited<ReturnType<typeof getApiPlayers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApiPlayersMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPlayers<TData = Awaited<ReturnType<typeof getApiPlayers>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlayers>>, TError, TData>>, request?: SecondParameter<typeof getApiPlayersMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPlayers<TData = Awaited<ReturnType<typeof getApiPlayers>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlayers>>, TError, TData>>, request?: SecondParameter<typeof getApiPlayersMutator>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPlayersQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const postApiPlayersEmailConfirmation = (
    playerConfirmationCommand: PlayerConfirmationCommand,
 options?: SecondParameter<typeof postApiPlayersEmailConfirmationMutator>,signal?: AbortSignal
) => {
      
      
      return postApiPlayersEmailConfirmationMutator<Unit>(
      {url: `https://api.dev.gocore.gg/api/Players/email-confirmation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: playerConfirmationCommand, signal
    },
      options);
    }
  


export const getPostApiPlayersEmailConfirmationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPlayersEmailConfirmation>>, TError,{data: PlayerConfirmationCommand}, TContext>, request?: SecondParameter<typeof postApiPlayersEmailConfirmationMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiPlayersEmailConfirmation>>, TError,{data: PlayerConfirmationCommand}, TContext> => {

const mutationKey = ['postApiPlayersEmailConfirmation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiPlayersEmailConfirmation>>, {data: PlayerConfirmationCommand}> = (props) => {
          const {data} = props ?? {};

          return  postApiPlayersEmailConfirmation(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiPlayersEmailConfirmationMutationResult = NonNullable<Awaited<ReturnType<typeof postApiPlayersEmailConfirmation>>>
    export type PostApiPlayersEmailConfirmationMutationBody = PlayerConfirmationCommand
    export type PostApiPlayersEmailConfirmationMutationError = unknown

    export const usePostApiPlayersEmailConfirmation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPlayersEmailConfirmation>>, TError,{data: PlayerConfirmationCommand}, TContext>, request?: SecondParameter<typeof postApiPlayersEmailConfirmationMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiPlayersEmailConfirmation>>,
        TError,
        {data: PlayerConfirmationCommand},
        TContext
      > => {

      const mutationOptions = getPostApiPlayersEmailConfirmationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const postApiPlayersSendEmailConfirmation = (
    sendEmailConfirmationCommand: SendEmailConfirmationCommand,
 options?: SecondParameter<typeof postApiPlayersSendEmailConfirmationMutator>,signal?: AbortSignal
) => {
      
      
      return postApiPlayersSendEmailConfirmationMutator<Unit>(
      {url: `https://api.dev.gocore.gg/api/Players/send-email-confirmation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendEmailConfirmationCommand, signal
    },
      options);
    }
  


export const getPostApiPlayersSendEmailConfirmationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPlayersSendEmailConfirmation>>, TError,{data: SendEmailConfirmationCommand}, TContext>, request?: SecondParameter<typeof postApiPlayersSendEmailConfirmationMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiPlayersSendEmailConfirmation>>, TError,{data: SendEmailConfirmationCommand}, TContext> => {

const mutationKey = ['postApiPlayersSendEmailConfirmation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiPlayersSendEmailConfirmation>>, {data: SendEmailConfirmationCommand}> = (props) => {
          const {data} = props ?? {};

          return  postApiPlayersSendEmailConfirmation(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiPlayersSendEmailConfirmationMutationResult = NonNullable<Awaited<ReturnType<typeof postApiPlayersSendEmailConfirmation>>>
    export type PostApiPlayersSendEmailConfirmationMutationBody = SendEmailConfirmationCommand
    export type PostApiPlayersSendEmailConfirmationMutationError = unknown

    export const usePostApiPlayersSendEmailConfirmation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPlayersSendEmailConfirmation>>, TError,{data: SendEmailConfirmationCommand}, TContext>, request?: SecondParameter<typeof postApiPlayersSendEmailConfirmationMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiPlayersSendEmailConfirmation>>,
        TError,
        {data: SendEmailConfirmationCommand},
        TContext
      > => {

      const mutationOptions = getPostApiPlayersSendEmailConfirmationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    